import { API_ENDPOINTS, API_HEADERS } from '../constants/api';

export interface AboutMemberPayload {
  id: number;
  title: string;
  description?: string;
  [key: string]: any;
}

export interface MemberPayload {
  id: number;
  name: string;
  title: string;
  job: string;
  image: string;
  [key: string]: any;
}

export const fetchAboutMember = async (): Promise<AboutMemberPayload | null> => {
  const response = await fetch(API_ENDPOINTS.aboutMember, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`About member request failed with status ${response.status}`);
  }

  const data = await response.json();

  if (Array.isArray(data)) {
    return data.length > 0 ? (data[0] as AboutMemberPayload) : null;
  }

  return data as AboutMemberPayload;
};

export const fetchMembers = async (): Promise<MemberPayload[]> => {
  const response = await fetch(API_ENDPOINTS.members, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Members request failed with status ${response.status}`);
  }

  const data = await response.json();

  return Array.isArray(data) ? data : [];
};
